import { redirect } from "react-router-dom"
import { fetchSocialListeningPost } from "../apis/admin"
import { fetchComment, fetchComments } from "../apis/comments"
import { fetchAdvocates } from "../apis/post"
import { ADMIN_LOAD_POSTS_LIMIT, COMMENT_TARGET_STATUS } from "../constants"
import { adminPostsPagePath } from "../links"

// the comment apis respond with 422 when comments are not enabled for the organization
const COMMENTS_NOT_ENABLED_STATUS = 422

export async function loadAdminCommentsPageData({ request }) {
  const url = new URL(request.url)
  const orgID = url.searchParams.get('orgID')
  const status = url.searchParams.get('status') || COMMENT_TARGET_STATUS.SCHEDULED

  const { comments, counts, error, errorCode } = await fetchComments({ orgID, status, limit: ADMIN_LOAD_POSTS_LIMIT })
  if (errorCode === COMMENTS_NOT_ENABLED_STATUS) {
    return redirect(adminPostsPagePath(orgID))
  }
  if (error) {
    throw new Error(error)
  }
  return { comments, counts, status }
}

export async function loadAdminSaveCommentData({ params, request }) {
  const url = new URL(request.url)
  const orgID = url.searchParams.get('orgID')
  const commentID = params.commentID

  const [advocatesData, commentData] = await Promise.all([
    fetchAdvocates({ orgID, includeSocialAccount: true }),
    commentID ? fetchComment({ orgID, commentID }) : Promise.resolve({ comment: null }),
  ])
  if (advocatesData.error) {
    throw new Error(advocatesData.error)
  }
  if (commentData.errorCode === COMMENTS_NOT_ENABLED_STATUS) {
    return redirect(adminPostsPagePath(orgID))
  }
  if (commentData.error) {
    throw new Error(commentData.error)
  }

  const comment = commentData.comment
  let socialListeningPost = comment?.SocialListeningPost || null
  if (!comment) {
    const { post, error } = await fetchSocialListeningPost({ orgID, postID: url.searchParams.get('socialListeningPostID') })
    if (error) {
      throw new Error(error)
    }
    socialListeningPost = post
  }

  return { advocates: advocatesData.advocates || [], comment, socialListeningPost }
}
